<template>
  <div class="jobs row">
    <div class="col-12">
      <div class="row">
        <section class="banner d-flex justify-content-center">
          <img src="@/assets/images/banner-escritorio.png" aria-hidden="true" v-if="!isMobile && $route.query.collection == 'escritorio'" />
          <img src="@/assets/images/banner-escritorio-mobile.png" class="m-3" aria-hidden="true" v-if="isMobile && $route.query.collection == 'escritorio'" />

          <img src="@/assets/images/banner-academia.png" aria-hidden="true" v-if="!isMobile && $route.query.collection == 'academia'" />
          <img src="@/assets/images/banner-academia-mobile.png" aria-hidden="true" v-if="isMobile && $route.query.collection == 'academia'" />

          <img src="@/assets/images/banner-estagio.png" aria-hidden="true" v-if="!isMobile && $route.query.collection == 'estagio'" />
          <img src="@/assets/images/banner-academia-mobile.png" aria-hidden="true" v-if="isMobile && $route.query.collection == 'estagio'" />
        </section>
      </div>

      <div class="row mt-3 d-none d-md-block">
        <div class="col-12 d-flex justify-content-center">

          <form action="/vagas" method="get" class="search-box">
            <input type="search" name="term" class="form-control" placeholder="Pesquise por vagas ou palavras-chave" />
            <button type="submit" class="btn btn-primary rounded-pill d-flex align-items-center"><magnify-icon class="h4 mr-1 mb-0" /> Buscar vagas</button>
          </form>

        </div>
      </div>


      <div class="row py-5">
        <div class="col-12 col-md-10 mx-auto">

          <div class="row" v-if="$route.query.collection == 'escritorio'">
            <div class="col-12 col-md-8">
              <img src="@/assets/images/textos-escritorio.png" aria-hidden="true" v-if="!isMobile" />
              <img src="@/assets/images/textos-escritorio-mobile.png" aria-hidden="true" width="100%" v-if="isMobile" class="mb-5" />
            </div>
            <div class="col-12 col-md-4">
              <IframeThumb videoId="QKACHB8e4OQ" style="height: 100%; min-height: 400px;">
                <img src="@/assets/images/img-video-escritorio.png" aria-hidden="true"  />
              </IframeThumb>
            </div>
            <div class="col-12 d-flex justify-content-center" v-if="isMobile">
              <img src="@/assets/images/textos-escritorio-mobile-2.png" aria-hidden="true" width="70%" class="mt-5"  />
            </div>
          </div>

          <div class="row mt-5 pt-5" v-if="$route.query.collection == 'escritorio'">
            <div class="col-11 mx-auto">
              <Slider>

                <div>
                  <img src="@/assets/images/foto-escritorio-2.png" aria-hidden="true"  />
                </div>
                <div>
                  <img src="@/assets/images/foto-escritorio-3.png" aria-hidden="true"  />
                </div>
                <div>
                  <img src="@/assets/images/foto-escritorio-4.png" aria-hidden="true"  />
                </div>
                <div>
                  <img src="@/assets/images/foto-escritorio-5.png" aria-hidden="true"  />
                </div>

              </Slider>
            </div>
          </div>

          <div class="row" v-if="$route.query.collection == 'academia'">
            <div class="col-8">
              <img src="@/assets/images/textos-academia.png" aria-hidden="true" v-if="!isMobile" />
            </div>
            <div class="col-4">
              <IframeThumb videoId="2Ekrjt6Bejk" style="height: 100%;">
                <img src="@/assets/images/img-video-academia.png" aria-hidden="true" v-if="!isMobile" />
              </IframeThumb>
            </div>
          </div>

          <div class="row mt-5 pt-5" v-if="$route.query.collection == 'academia'">
            <div class="col-12">
              <Slider>
                <div>
                  <img src="@/assets/images/foto-academia-1.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-academia-2.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-academia-3.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-academia-4.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-academia-5.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-academia-6.png" aria-hidden="true" v-if="!isMobile" />
                </div>
              </Slider>
            </div>
          </div>


          <div class="row" v-if="$route.query.collection == 'estagio'">
            <div class="col-12 d-flex justify-content-center mt-5">
              <img src="@/assets/images/textos-estagio.png" aria-hidden="true" />
            </div>
          </div>

          <div class="row mt-5 pt-5" v-if="$route.query.collection == 'estagio'">
            <div class="col-12">
              <Slider>
                <div>
                  <img src="@/assets/images/foto-estagio-1.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-estagio-2.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-estagio-3.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-estagio-4.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-estagio-5.png" aria-hidden="true" v-if="!isMobile" />
                </div>
                <div>
                  <img src="@/assets/images/foto-estagio-6.png" aria-hidden="true" v-if="!isMobile" />
                </div>
              </Slider>
            </div>
          </div>

        </div>
      </div>
      

      
      <div class="row" id="oportunidades">
        <div class="col-10 mx-auto">
          <div class="d-flex justiy-content-center">
            <h1>Nossas oportunidades</h1>
          </div>
          <Jobs :key="$route.fullPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Jobs from "@/components/jobs/Jobs.vue";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
import Slider from "@/components/Slider.vue";
import IframeThumb from "@/components/IframeThumb.vue";

export default {
  name: "JobsList",

  data() {
    return {
    };
  },

  computed: {
    selectedTeam(){
      return this.$route.query.collection || null;
    },

    teamInfos() {
      return (
        this.$store.state.teams.find(
          (team) => team.slug == this.selectedTeam
        ) || {}
      );
    },

    isMobile: function(){
      return window.innerWidth < 720;
    },
  },

  components: {
    Jobs,
    MagnifyIcon,
    Slider,
    IframeThumb
  },
};
</script>

<style lang="scss" scoped>
  .jobs{
    background-image: url("../assets/images/bg-site.png");
    margin: 0 -15px;
    background-size: 100vw;
  }

  .banner {
    width: 100%;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      object-fit: cover;
      width: 100%;
    }
  }

  .search-box{
    width: 500px;
    box-shadow: 0px 4px 40px 0px #0000000D;
    border-radius: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #fff;
    transform: translateY(-100px);
    @media (max-width: 600px){
      transform: none;
    }

    .form-control{
      min-height: 52px;
      flex-grow: 1;
      margin: 0;
      border: none;
      border-radius: inherit;
    }
    .btn{
      flex-shrink: 0;
    }
  }


  /deep/ .carousel-container{
    img{
      width: 100%;
      object-fit: cover;
      border-radius: 18px;
    }

    .tns-nav{
      width: 100%;
      position: absolute;
      bottom: -40px;
      display: flex;
      justify-content: center;
      gap: 10px;

      button{
        width: 15px;
        height: 15px;
        background-color: #EAEAEA;
        border-radius: 50%;
        border: none;

        &.tns-nav-active{
          background: #050D9A;
        }
      }
    }
  }

  

  #oportunidades{
    h1{
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0em;
      text-align: center;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 50px;
      display: inline-block;
      padding: 10px 50px;
      margin: 80px auto 50px auto;

    }
  }
</style>
